export default {
  common: {
    loginOut: "Exit the system",
    cancel: "cancel",
    ok: "ok",
    save: "save",
    hectare: "hectare",
    forestXiaoBan: "forest xiao ban",
    wetlandXiaoBan: "wetland xiao ban",
    a: "a",
    forestCoverage: "forest coverage",
    oldAndFamousTrees: "Old and Famous Trees",
    plant: "plant",
    linZhang: "lin zhang",
    cooperativeUnit: "cooperative unit",
    ranger: "ranger",
    day: "day",
    week: "week",
    month: "month",
    currMonth: "this month",
    currYear: "this year",
    cumulative: "cumulative",
    reporting: "reporting",
    issue: "issue",
    CC: "CC",
    serialNumber: "index",
    type: "type",
    createTime: "create time",
    deadline: "deadline",
    deadlineTip: "please select the deadline",
    days: "day",
    people: "people",
    loadMore: "load more",
    browserNSupportVideo: "Your browser does not support video tags",
    contentTip: "please input content",
    send: "send",
    pleaseSelect: "Please select again ",
    noDataTip: "No data available",
    play: "play",
    all: "all",
    state: "state",
    title: "title",
    search: "search",
    reset: "reset",
    packUp: "retract",
    open: "open",
    selectStartTimeTip: "please select start time",
    selectEndTimeTip: "please select end time",
    redInput: "please complete the red box part of the form",
    select: "select",
    classification: "classification",
    individualPeople: "individual people",
    manyPeople: "many people",
    notEmpty: "Cannot be empty",
    add: "add",
    edit: "edit",
    view: "view",
    content: "content",
    checkState: "check state",
    pass: "pass",
    deny: "deny",
    checkAdvise: "Audit opinion",
    checkAdviseTip: "please input Audit opinion...",
    commit: "commit",
    commitSuccTip: "commit success!",
    time: "time",
    name: "name",
    nameTip: "please input name",
    describe: "describe",
    operation: "operation",
    map: "map",
    list: "list",
    addTo: "add",
    legend: "legend",
    registrationTime: "registration time",
    registrant: "Registrant",
    administrativeDistrict: "administrative district",
    currAdd: "currently added",
    provience: "provience",
    city: "city",
    area: "area",
    country: "country",
    village: "village",
    pending: "pending",
    distributed: "distributed",
    completed: "completed",
    withdrawn: "withdrawn",
    saveSuccTip: "save success",
    trueSelect: "Confirm selection",
    atLeastOne: "Please select at least one person!",
    etc: "etc.",
    recall: "recall",
    trueRecall: "Confirmation withdrawal?",
    trueRecallTip: "Are you sure you want to withdraw?",
    recallSucc: "Withdrawal successful",
    front: "front",
    commitContent: "commit content",
  },
  upload: {
    uploadPic: "upload picture",
    fileFormat: "The file format is not correct. Please select again",
    nullFile: "Empty files are not allowed to be uploaded",
    fileSize: "File size exceeds",
    maxSelect: "Most choices this time",
    pleaseSelect: "files,Please select again !",
    picture: "picture",
    annex: "annex",
    supportFormat: "Currently, the file format supported for uploading is",
    maxSize: "Maximum single attachment",
    maxAdd: "You can add at most this time",
    preview: "preview",
    download: "download",
    delete: "delete",
    selectFile: "select file",
    fileDelete: "file removal",
    isTrueDelete:
      "Are you sure you want to move the current file to the queue to be deleted?",
    allFormat: "allFormat",
    recommit: "Attachment upload failed, please click Submit again!",
    noDownloadPath: "No download path!",
  },
  login: {
    acountTip: "please input your aount name",
    passwordTip: "please input your password",
    login: "Login",
    forgetPassword: "forget password",
    recordNo: "this is record No",
    backLogin: "back login",
    findPassword: "retrieve password ",
    phoneCode: "please input verification code",
    getCode: "get code",
    reSend: "resend",
    newPassword: "please input new password",
    determine: "determine",
    noUserMsg: "user does not exist",
    accPwdNOMsg: "account or password cannot be empty!",
    getCodeSuccessMsg: "Verification code obtained successfully",
    phoneErrorMsg:
      "The account number cannot be empty or the format is incorrect!",
    noPhoneCodeMsg: "Verification code cannot be empty",
    pwdErrorMsg: "The password cannot be empty and no less than 6 digits",
    findPwdSuccessMsg: "Password recovered successfully",
    logining: "logining...",
  },
  signOut: {
    sysTip: "system prompt",
    determineSignOut: "Are you sure you want to exit the system?",
  },
  home: {
    pendingTip: "",
    unreadNotice: "unread notice",
    pendingTask: "To do tasks",
    checkPending: "",
    findPending: "",
    workOrder: "",
    oneForestOneFile: "",
    responsibilityArea: "",
    woodlandArea: "woodland area",
    wetlandArea: "wetland area",
    forestProtection: "forest protection",
    forestProtectionRanking: "forest protection ranking",
    taskStatus: "task status",
    taskStatusRanking: "task status ranking",
  },
  task: {
    taskTitle: "task title",
    urgency: "urgency",
    reportingPeople: "initiator",
    responsibilitor: "responsibilitor",
    taskStatus: "task status",
    deadline: "deadline",
    usedTime: "used time",
    start: "start",
    end: "end",
    assist: "assist",
    forward: "forward",
    ignore: "ignore",
    taskDynamics: "task dynamics",
    toScene: "to the scene",
    forwardMsg: "task forwarded successfully!",
    assistMsg: "task launch assistance successful!",
    locationType: "location type does not exist",
    CCDetails: "task CC details",
    discussionGroup: "discussion group",
    sendContent: "Please fill in what you want to send",
    taskTitleTip: "please input task title",
    fqPeople: "initiator",
    fqPeopleTip: "please input initiator ",
    fqTime: "initiate time",
    sbTaskInfo: "report task information",
    sbTitle: "report title",
    sbTitleTip: "please input reporting title",
    sbContent: "reporting content",
    sbContentTip: "please input reporting content",
    urgencyTip: "please select urgency",
    sbType: "reporting type",
    sbTypeTip: "please select reporting type",
    sbError: "unable to find the superior, failed to report!",
    addTaskSucc: "Task report added successfully",
    editTaskSucc: "Task submitted and edited successfully",
    xfAddTaskSucc: "Task issued and added successfully",
    xfEditTaskSucc: "The task was distributed and edited successfully",
    xfTaskInfo: "issue task information",
    taskContent: "task content",
    taskContentTip: "please input task content",
    responsibilitors: "responsibilitors",
    responsibilitorsTip: "Please select the person in charge of the task",
  },
  check: {
    target: "target",
    fillTitle: "fill in the title",
    fillPeople: "filled by",
    fillTime: "fill time",
    fillType: "fill type",
    classificationTip: "please input classification target",
    targetTip: "please input target",
    fillTitleTip: "please input fill title",
    checkResult: "check result",
    participateIn: "participate in people",
  },
  forestProtect: {
    signInstructions: "sign in instructions",
    forestPatrolTime: "forest patrol time",
    forestTour: "forest tour(m)",
  },
  find: {
    discoverer: "discoverer",
    discovererTip: "please input discoverer",
    findTime: "find time",
    location: "location",
    check: "check",
    findCheck: "discovery audit",
    checkPeople: "reviewer",
  },
  reformArea: {
    reformArea: "reform area",
    reformAreaTip: "please input reform area",
    reformAreaLegend: "Legend of reform demonstration area",
    reformAreaInfo: "reform area information",
    reformAreaName: "Name of demonstration area",
    reformAreaNameTip: "please enter the name of reform demonstration area",
    reformAreaType: "type of demonstration area",
    reformAreaTypeTip: "please select the type of demonstration area",
    reformAreaLevel: "level of demonstration area",
    reformAreaLevelTip: "please select the level of demonstration area",
    location: "location",
    reformAreaExplain: "demonstration area description",
    reformAreaLocation: "location of demonstration area",
    addSucc: "Reform demonstration zone added successfully!",
  },

  workOrder: {
    workOrder: "work order",
    addWorkOrder: "add work order",
    articleTitle: "article title",
    articleTitleTip: "please input article title",
    receiver: "receiver",
    receiverTip: "please select receiver",
    workOrderNum: "work order Num",
    workOrderNumTip: "XX Lin changban Letter No. XXX",
    workOrderHeader: "work order header",
    workOrderHeaderTip: "XXX director Lin's Office",
    workOrderType: "work order type",
    workOrderTypeTip: "please select work order type",
    distributor: "distributor",
    complete: "complete",
    oneWorkOrder: "Send a work order",
    clickComplete: "click complete",
  },
  forestProtectList: {
    themeName: "theme name",
    themeNameTip: "please input theme name",
    theme: "theme/functional area",
    participants: "participants",
    location: "location",
    noteTaker: "noteTaker",
  },
};
